const imagesService = {
  getBaseUrl: (imgUrl) => {
    if (!imgUrl) {
      return '#'
    }
    const baseUrl = imgUrl.split('/')
    baseUrl[baseUrl.length - 1] = ''
    return baseUrl.join('/')
  },

  getOriginalExt: (imgUrl) => {
    if (!imgUrl) {
      return '#'
    }
    return imgUrl.split('.').pop()
  },

  getFallbackUrl: (imgUrl) => {
    if (!imgUrl) {
      return '#'
    }
    return `${imagesService.getBaseUrl(
      imgUrl
    )}w800.${imagesService.getOriginalExt(imgUrl)}`
  }
}

export default imagesService
